import React from "react";
import { Link } from "react-router-dom";
import { DOCENCIA, DISCIPLINA, IMG } from "@/content/site";
import { Container, Eyebrow, H2, Body, ArrowLink, Reveal } from "@/components/site/ui";

const DocenciaBlock = () => (
    <section data-testid="home-docencia" data-section-id="docencia" className="relative bg-[#0E2018] py-24 md:py-32">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-16">
            <Reveal className="lg:col-span-5">
                <Eyebrow>{DOCENCIA.eyebrow}</Eyebrow>
                <H2>{DOCENCIA.title}</H2>
                <Body className="mt-6">{DOCENCIA.lead}</Body>
                <ul className="mt-8 flex flex-col gap-3">
                    {DOCENCIA.principios.map((p) => (
                        <li key={p} className="flex gap-4 font-serif italic text-[16px] leading-[1.5] text-[#D7D1BF]">
                            <span aria-hidden="true" className="mt-3 block w-4 h-px bg-[#C7A659] shrink-0" />
                            {p}
                        </li>
                    ))}
                </ul>
                <div className="mt-10">
                    <ArrowLink to="/docencia" testId="home-docencia-link">Docência</ArrowLink>
                </div>
            </Reveal>
            <Reveal className="lg:col-span-7" delay={150}>
                <Link to="/docencia#disciplina" data-testid="home-disciplina-card" className="group relative block overflow-hidden rounded-sm border border-[#C7A659]/35 hover:border-[#C7A659] transition-colors">
                    <img src={IMG.docencia} alt="Notebook exibindo uma videoaula, ao lado de um caderno aberto" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-[1.02] transition-[opacity,transform] duration-700" />
                    <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-br from-[#0A1812]/95 via-[#0A1812]/85 to-[#0A1812]/60" />
                    <div className="relative p-8 md:p-12">
                        <p className="inline-flex items-center gap-2 font-sans text-[10px] uppercase tracking-[0.26em] text-[#C7A659] border border-[#C7A659]/50 rounded-full px-3 py-1">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#C7A659]" /> {DISCIPLINA.status}
                        </p>
                        <h3 data-testid="disciplina-nome" className="mt-8 font-serif font-light text-[28px] sm:text-[34px] lg:text-[40px] leading-[1.1] text-[#F2EFE5] text-balance">{DISCIPLINA.nome}</h3>
                        <p className="mt-3 font-serif italic text-[17px] md:text-[19px] text-[#C7A659]">{DISCIPLINA.subtitulo}</p>
                        <p className="mt-8 font-sans font-light text-[14px] leading-[1.8] text-[#D7D1BF] max-w-xl">{DISCIPLINA.proposta}</p>
                        <p className="mt-5 font-serif text-[17px] leading-[1.5] text-[#F2EFE5] max-w-xl">{DISCIPLINA.objetivo}</p>
                        <span className="mt-10 inline-flex items-center gap-3 font-sans text-[11px] uppercase tracking-[0.24em] text-[#C7A659]">
                            Ver proposta da disciplina <span aria-hidden="true" className="transition-transform group-hover:translate-x-1">→</span>
                        </span>
                    </div>
                </Link>
            </Reveal>
        </Container>
    </section>
);

export default DocenciaBlock;
